import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Settings.css";

const Settings = () => {
    const [user, setUser] = useState({ name: "", email: "", password: "" });
    const [loading, setLoading] = useState(false); // ✅ Add loading state


        useEffect(() => {
            fetchUserSettings();
        }, []);

    const fetchUserSettings = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                console.log("❌ No token found");
                return;
            }

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            console.log("✅ API Response:", response.data); // ✅ Log backend response

            if (!response.data || !response.data.role) {
                console.error("❌ Role is missing in API response");
            }

            setUser(response.data);
        } catch (error) {
            console.error("❌ Error fetching user data:", error);
        }
    };


    const handleUpdateUser = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = localStorage.getItem("adminToken");

        if (!token) {
            alert("Session expired. Please log in again.");
            window.location.href = "/admin/login";
            return;
        }

        if (!user.name.trim() || !user.email.trim()) {
            alert("Name and email cannot be empty.");
            setLoading(false);
            return;
        }

        let updatedData = { name: user.name, email: user.email };

        if (user.password && user.password.trim().length > 0) {
            updatedData.password = user.password;
        }
        else if (user.password !== undefined && user.password.length > 0 && user.password.length < 6) {
            alert("Password must be at least 6 characters.");
            setLoading(false);
            return;
        }

        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/users/me`, updatedData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log("✅ Profile Updated:", response.data);
            alert("Profile updated successfully!");
            fetchUserSettings(); // ✅ Refresh user info after update
        } catch (error) {
            console.error("❌ Error updating profile:", error);
            alert(error.response?.data?.message || "Failed to update profile. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="settings-container">
            <h1>Settings</h1>
            <div className="settings-section">
                <h2>Profile Settings</h2>
                <form onSubmit={handleUpdateUser}>
                    <label>
                        Name:<br />
                        <input
                            type="text"
                            value={user.name}
                            onChange={(e) => setUser({ ...user, name: e.target.value })}
                            required
                        />
                    </label>
                    <label>
                        Email:<br />
                        <input
                            type="email"
                            value={user.email}
                            onChange={(e) => setUser({ ...user, email: e.target.value })}
                            required
                        />
                    </label>
                    <label>
                        Password (leave empty to keep current password):<br />
                        <input
                            type="password"
                            value={user.password}
                            onChange={(e) => setUser({ ...user, password: e.target.value })}
                        />
                    </label>
                    <button type="submit" disabled={loading}>
                        {loading ? "Updating..." : "Update Profile"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Settings;
